/**
 * Server-safe product list query function.
 *
 * Extracted from product.ts to avoid pulling in client-only code
 * (useRouter, React hooks) into Server Components.
 */
import {ApolloClient, NormalizedCacheObject} from '@apollo/client';
import {
    ProductListItemsDocument,
    ProductListItemsQuery,
} from '@/framework/gql/products.graphql';

export async function getProductListItems(
    client: ApolloClient<NormalizedCacheObject>,
    options: Record<string, unknown>,
    locale: string,
): Promise<ProductListItemsQuery> {
    const localeOptions = {
        language: locale,
        ...options,
    };

    const {data} = await client.query({
        query: ProductListItemsDocument,
        variables: localeOptions,
    });

    return data;
}
